import { render, staticRenderFns } from "./DetailsBox.vue?vue&type=template&id=6da316ae&scoped=true"
var script = {}
import style0 from "./DetailsBox.vue?vue&type=style&index=0&id=6da316ae&prod&scoped=true&lang=css"
import style1 from "./DetailsBox.vue?vue&type=style&index=1&id=6da316ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da316ae",
  null
  
)

export default component.exports